import { fetch } from '@/modules/fetch';
// POST a GraphQL query to the Santiment API (SanAPI,
// https://api.santiment.net/graphql — schema docs at
// https://academy.santiment.net/for-developers) and resolve with the parsed
// JSON envelope. The request body is exactly `{ query }` — no
// variables/operationName envelope, so interpolate values into the query
// string. Per-field GraphQL errors do NOT reject: SanAPI nulls the failing
// field beside the rest of `data` (an unknown slug in a batched document
// costs that alias alone), and consumers read a null field as unpriced.
// Only an envelope with no `data` at all and a non-empty `errors` array
// rejects — a total failure such as a rejected query or an expired key —
// with the error messages joined. The HTTP status is deliberately not
// checked — the promise otherwise rejects only on a network-phase failure
// or a non-JSON body. Auth: VITE_SAN_APIKEY is read at call time and sent as an
// `Apikey` Authorization header, omitted entirely when unset/empty. The key
// is an internal-access key with no rate limits — safe to ship in the
// client bundle, and consumers size short-interval polling and per-row
// batched fetches on that headroom. Pass the query's response shape as T at
// the call site — the module's one boundary cast, never validated at runtime.
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- return-only T is the documented boundary cast: the caller-declared shape is the contract
export async function fetchSanApi<T = unknown>(
  query: string,
): Promise<{ data: T }> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (
    import.meta.env.VITE_SAN_APIKEY != null &&
    import.meta.env.VITE_SAN_APIKEY !== ''
  ) {
    headers.Authorization = `Apikey ${import.meta.env.VITE_SAN_APIKEY}`;
  }
  const res = await fetch('https://api.santiment.net/graphql', {
    method: 'POST',
    headers,
    body: JSON.stringify({ query }),
  });
  const json: unknown = await res.json();
  // GraphQL responses carry no runtime schema here — the caller-declared T
  // IS the contract, so this is the module's one boundary cast.
  const envelope = json as { data: T; errors?: { message: string }[] };
  if (
    envelope.data == null &&
    Array.isArray(envelope.errors) &&
    envelope.errors.length > 0
  ) {
    throw new Error(
      `SanAPI: ${envelope.errors.map((e) => e.message).join('; ')}`,
    );
  }
  return { data: envelope.data };
}
